
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.9998 8.56998C12.2098 8.56998 11.5698 9.20998 11.5698 9.99998C11.5698 10.79 12.2098 11.43 12.9998 11.43C13.7898 11.43 14.4298 10.79 14.4298 9.99998C14.4298 9.20998 13.7898 8.56998 12.9998 8.56998Z' fill='#323232'/><path d='M13.2098 2.99999C9.36982 2.88999 6.20982 5.86999 6.01982 9.63999L4.09982 12.2C3.84982 12.53 4.08982 13 4.49982 13H5.99982V16C5.99982 17.1 6.89982 18 7.99982 18H8.99982V20C8.99982 20.55 9.44982 21 9.99982 21H14.9998C15.5498 21 15.9998 20.55 15.9998 20V16.32C18.4398 15.16 20.0998 12.64 19.9998 9.73999C19.8598 6.11999 16.8198 3.10999 13.2098 2.99999ZM15.9998 9.99999C15.9998 10.13 15.9898 10.26 15.9798 10.39L16.8098 11.05C16.8898 11.11 16.9098 11.21 16.8598 11.3L16.0598 12.69C16.0098 12.78 15.8998 12.81 15.8198 12.78L14.8298 12.38C14.6198 12.54 14.3998 12.67 14.1598 12.77L13.9998 13.83C13.9898 13.93 13.8998 14 13.7998 14H12.1998C12.0998 14 12.0198 13.93 11.9998 13.83L11.8498 12.77C11.5998 12.67 11.3798 12.54 11.1698 12.38L10.1798 12.78C10.0898 12.81 9.97983 12.78 9.92982 12.69L9.12982 11.3C9.07982 11.22 9.09982 11.11 9.17982 11.05L10.0198 10.39C10.0098 10.26 9.99982 10.13 9.99982 9.99999C9.99982 9.86999 10.0198 9.72999 10.0398 9.60999L9.18982 8.94999C9.10982 8.88999 9.08982 8.78999 9.13982 8.68999L9.93982 7.30999C9.98982 7.21999 10.0898 7.18999 10.1798 7.21999L11.1798 7.61999C11.3798 7.46999 11.6098 7.32999 11.8498 7.22999L11.9998 6.16999C12.0198 6.06999 12.0998 5.99999 12.1998 5.99999H13.7998C13.8998 5.99999 13.9798 6.06999 13.9998 6.16999L14.1498 7.22999C14.3898 7.32999 14.6098 7.45999 14.8198 7.61999L15.8198 7.21999C15.9098 7.18999 16.0198 7.21999 16.0598 7.30999L16.8598 8.68999C16.9098 8.77999 16.8898 8.88999 16.8098 8.94999L15.9598 9.60999C15.9898 9.72999 15.9998 9.85999 15.9998 9.99999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-psychology`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPsychology

    ```js
    <b-new-b-icon-psychology />
    ```
</docs>


